import { Close } from "@mui/icons-material";
import { Box, DialogTitle, IconButton, Stack, Typography } from "@mui/material";
import palette from "theme/palette";

interface ModalHeaderProps {
  title?: string | null;
  onClose: () => void;
}

const ModalHeader = ({ title, onClose }: ModalHeaderProps) => {
  return (
    <DialogTitle
      sx={{
        px: 0,
        borderBottom: `1px solid ${palette.divider}`,
      }}>
      <Stack
        direction='row'
        alignItems='center'
        justifyContent='space-between'
        spacing={2}>
        <Box>
          <Typography
            variant='h20'
            sx={{ fontWeight: 800 }}>
            Генерация вопросов
          </Typography>
          <Typography
            variant='body14rg'
            sx={{ color: "text.secondary", mt: 0.25 }}>
            Карта компетенций · {title || "Без названия"}
          </Typography>
        </Box>
        <IconButton
          size='small'
          onClick={onClose}
          sx={{
            borderRadius: 1,
            border: `1px solid ${palette.divider}`,
            backgroundColor: "bgSwitch",
          }}>
          <Close fontSize='small' />
        </IconButton>
      </Stack>
    </DialogTitle>
  );
};

export default ModalHeader;
